import { Expose } from 'class-transformer'
import { Entity } from '@/app/common/base/entity'

export class MortgageTimeline extends Entity<MortgageTimeline> {
    @Expose()
    label!: string

    @Expose()
    completed!: boolean

    @Expose()
    active!: boolean
}
